import { Language } from '../../lang/Language'

export class PlayOutOfTurnError extends Error {
  constructor(playerId: string) {
    super(Language.strings.error.table.playOutOfOrder(playerId))
  }
}
